import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Zap } from "./Icons";
import { Organisation } from "../types";

interface UpgradePromptProps {
  currentOrg: Organisation;
  title: string;
  message: string;
  upgradeLink?: string;
  onUpgrade?: () => void;
  onDismiss?: () => void;
  testId?: string;
}

export const UpgradePrompt: React.FC<UpgradePromptProps> = ({
  currentOrg,
  title,
  message,
  upgradeLink,
  onUpgrade,
  onDismiss,
  testId,
}) => {
  return (
    <div className="bg-indigo-600 rounded-2xl p-6 text-white shadow-xl shadow-indigo-500/20 flex flex-col md:flex-row items-center justify-between gap-6 overflow-hidden relative">
      <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/4 opacity-10 pointer-events-none">
        <Zap size={200} />
      </div>

      {onDismiss && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDismiss();
          }}
          className="absolute top-2 right-2 p-1.5 text-white/60 hover:text-white rounded-full hover:bg-white/10 transition z-20"
          aria-label="Dismiss"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-x"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      )}

      <div className="relative z-10 flex items-center gap-4">
        <div className="w-12 h-12 bg-white/20 backdrop-blur-md rounded-xl flex items-center justify-center shrink-0 shadow-lg shadow-indigo-900/10">
          <Zap size={24} className="text-white" />
        </div>
        <div>
          <h3 className="font-bold text-lg">{title}</h3>
          <p className="text-indigo-100 text-sm">{message}</p>
        </div>
      </div>

      <button
        onClick={(e) => {
          e.stopPropagation();
          onUpgrade?.();
        }}
        data-testid={testId}
        className="relative z-10 px-6 py-2.5 bg-white text-indigo-600 rounded-lg hover:bg-slate-50 font-bold text-sm transition shadow-lg shadow-indigo-900/10 whitespace-nowrap flex items-center gap-2 group"
      >
        {upgradeLink || "Upgrade to Team"}
        <ArrowRight
          size={16}
          className="group-hover:translate-x-0.5 transition-transform"
        />
      </button>
    </div>
  );
};
